/**
 * NOTE: 年末調整（YearEndAdjustment）インスタンス一覧の route-local mock 分岐。
 * バックエンド API 対応後は本ファイルごと削除し、実 API を直接利用する。
 */
import { useQuery } from '@tanstack/react-query';

import {
  getOperationPackageInstances as getOperationPackageInstancesApi,
  type OperationPackageInstancesResponse,
  type OwnerProduct,
} from '@/features/operation-packages/api';
import { operationPackageQueryKeys } from '@/features/operation-packages/hooks';

import { isMockYeaPatternId } from '../../-shared/yearEndAdjustmentMockIds';

const EMPTY_OPERATION_PACKAGE_INSTANCES: OperationPackageInstancesResponse = {
  items: [],
  count: 0,
  maxPage: 1,
  length: 0,
  page: 1,
};

/** NOTE: 実 API 確定後は差し替える */
export const useGetOperationPackageInstances = (
  ownerProduct: OwnerProduct,
  patternId: string,
  options?: {
    enabled?: boolean;
    page?: number;
    pageSize?: number;
    targetId?: string;
  },
) => {
  const page = options?.page ?? 1;
  const pageSize = options?.pageSize ?? 50;
  const targetId = options?.targetId;
  const { data, isPending, error } = useQuery({
    queryKey: operationPackageQueryKeys.instances(
      ownerProduct,
      patternId,
      page,
      pageSize,
      targetId,
    ),
    queryFn: (): Promise<OperationPackageInstancesResponse> => {
      if (isMockYeaPatternId(patternId)) {
        return Promise.resolve(
          structuredClone(EMPTY_OPERATION_PACKAGE_INSTANCES),
        );
      }
      return getOperationPackageInstancesApi(ownerProduct, patternId, {
        page,
        pageSize,
        targetId,
      });
    },
    enabled: options?.enabled ?? true,
  });
  return { data, isPending, error };
};
